module.exports = __webpack_public_path__ + "static/img/24.34d7e485.png";